import { request } from "../../../app/api-client/ApiClient";

/**
 * Metodo para obtener las maquinas asocuadas a un admin
 * @param {Integer} idAdmin 
 */
export function getlistUbicacionesAdmin(dispatch, id, Estado, filter, page, size) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/ubicacion/list/multifilter/${id}/${Estado}?filter=${filter}&page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}
export function updateStatus(dispatch, id) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/ubicacion/changeStatus/${id}`;
	return request({
		url: url,
		method: "PUT",
	}, dispatch);
}
export function crearUbicaciones(dispatch, Request) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/ubicacion/create`,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}
export function EditarUbicaciones(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/ubicacion/update`;
	return request({
		url: url,
		method: "PUT",
		body: JSON.stringify(Request),
	}, dispatch);
}
export function updatelocation(dispatch, Evbi,location) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/evbi/update/location/${Evbi}/${location}`;
	return request({
		url: url,
		method: "PUT",
		body: JSON.stringify(Request),
	}, dispatch);
}
export function getlistUbicacionesUsers(dispatch, id, filter, page, size) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/ubicacion/list/active/cliente/${id}?&page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}
export function clientOfUser(dispatch, id) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/cliente/find/hash/${id}`,
		method: "GET",
	}, dispatch);
}